import { Link } from "react-router";

export type BreadcrumbItem = {
  name: string;
  href?: string;
  /** スマホ (767px 以下) では出さない。頁の見出しに同じ題があるとき、長い題の折れと矢印のずれを避ける */
  hideOnMobile?: boolean;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
  homeUrl?: string;
};

export function Breadcrumb({ items, className = "", homeUrl = "/" }: BreadcrumbProps) {
  return (
    <nav aria-label="パンくずリスト" className={className}>
      <ol className="flex items-center flex-wrap gap-1 text-[13px] md:text-[14px]">
        {/* ホーム (yumesaku.tech のトップ) > ゆめさくエンジニア > 各頁。メインのサイトのパンくず (LabBreadcrumb) とそろえる (2026-10-21 代表) */}
        <li className="flex items-center">
          <a
            href="https://yumesaku.tech/"
            className="-my-3 py-3 text-gray-500 hover:text-shegate-accent transition-colors"
          >
            ホーム
          </a>
        </li>
        <li className="flex items-center">
          <span className="mx-2 text-gray-400" aria-hidden="true">›</span>
          <Link
            to={homeUrl}
            className="-my-3 py-3 text-gray-500 hover:text-shegate-accent transition-colors"
          >
            ゆめさくエンジニア
          </Link>
        </li>

        {items.map((item, index) => (
          <li key={index} className={`${item.hideOnMobile ? "hidden md:flex" : "flex"} items-baseline`}>
            {/* Separator */}
            <span className="mx-2 text-gray-400" aria-hidden="true">›</span>

            {/* Link or Current */}
            {item.href ? (
              <Link
                to={item.href}
                className="relative after:absolute after:left-1/2 after:top-1/2 after:h-[max(100%,44px)] after:w-[max(100%,44px)] after:-translate-x-1/2 after:-translate-y-1/2 after:content-[''] text-gray-500 hover:text-shegate-accent transition-colors"
              >
                {item.name}
              </Link>
            ) : (
              <span className="text-gray-700">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
